import { types } from 'mobx-state-tree';

const preventScrollHandler = e => e.preventDefault();

export const ScrollControllerStore = types
  .model('ScrollControllerStore', {
    scrollbarWidth: types.optional(types.number, 0),
  })
  .actions(self => ({
    afterCreate: () => {
      const outer = document.createElement('div');
      const inner = document.createElement('div');
      outer.style.overflow = 'scroll';
      document.body.appendChild(outer);
      outer.appendChild(inner);
      const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;
      document.body.removeChild(outer);
      this.html = document.querySelector('html');
      self.setScrollbarWidth(scrollbarWidth);
    },

    setScrollbarWidth: value => {
      self.scrollbarWidth = value;
    },

    lock: () => {
      document.body.style.paddingRight = `${self.scrollbarWidth}px`;
      document.body.style.overflow = 'hidden';
    },

    unlock: () => {
      document.body.style.paddingRight = '';
      document.body.style.overflow = '';
    },

    lockWithScrollbar: () => {
      document.body.style.pointerEvents = 'none';
      // if (self.scrollbarWidth === 0) {
      // 	self.lock();
      // } else {
      if (window.addEventListener) {
        // older FF
        window.addEventListener('DOMMouseScroll', preventScrollHandler, false);
      }
      window.addEventListener('mousewheel', preventScrollHandler);
      window.addEventListener('wheel', preventScrollHandler);
      window.addEventListener('touchmove', preventScrollHandler, { passive: false });
      window.addEventListener('keydown', preventScrollHandler);
      // }
    },

    unlockWithScrollbar: () => {
      document.body.style.pointerEvents = '';
      // if (self.scrollbarWidth === 0) {
      // 	self.unlock();
      // } else {
      if (window.addEventListener) {
        // older FF
        window.removeEventListener('DOMMouseScroll', preventScrollHandler, false);
      }
      window.removeEventListener('mousewheel', preventScrollHandler);
      window.removeEventListener('wheel', preventScrollHandler);
      window.removeEventListener('touchmove', preventScrollHandler, { passive: false });
      window.removeEventListener('keydown', preventScrollHandler);
      // }
    },
  }));

export default ScrollControllerStore;



// WEBPACK FOOTER //
// ./src/stores/ScrollControllerStore.js